"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const adaptorforversion_1 = require("./adaptorforversion");
const jsonrpc_1 = require("./jsonrpc");
const requests = __importStar(require("./requests"));
const rpcclients_1 = require("./rpcclients");
class Client {
    static connect(url) {
        return __awaiter(this, void 0, void 0, function* () {
            const useHttp = url.startsWith("http://") || url.startsWith("https://");
            const client = useHttp ? new rpcclients_1.HttpClient(url) : new rpcclients_1.WebsocketClient(url);
            return this.detectVersion(client);
        });
    }
    static detectVersion(client) {
        return __awaiter(this, void 0, void 0, function* () {
            const req = jsonrpc_1.createJsonRpcRequest(requests.Method.Status);
            const response = yield client.execute(req);
            const result = response.result;
            if (!result || !result.node_info) {
                throw new Error("Unrecognized format for status response");
            }
            const version = result.node_info.version;
            if (typeof version !== "string") {
                throw new Error("Unrecognized version format: must be string");
            }
            return new Client(client, adaptorforversion_1.adaptorForVersion(version));
        });
    }
    constructor(client, adaptor) {
        this.client = client;
        this.p = adaptor.params;
        this.r = adaptor.responses;
    }
    disconnect() {
        this.client.disconnect();
    }
    abciInfo() {
        return __awaiter(this, void 0, void 0, function* () {
            const query = { method: requests.Method.AbciInfo };
            return this.doCall(query, this.p.encodeAbciInfo, this.r.decodeAbciInfo);
        });
    }
    abciQuery(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const query = { params: params, method: requests.Method.AbciQuery };
            return this.doCall(query, this.p.encodeAbciQuery, this.r.decodeAbciQuery);
        });
    }
    block(height) {
        return __awaiter(this, void 0, void 0, function* () {
            const query = { method: requests.Method.Block, params: { height: height } };
            return this.doCall(query, this.p.encodeBlock, this.r.decodeBlock);
        });
    }
    blockResults(height) {
        return __awaiter(this, void 0, void 0, function* () {
            const query = {
                method: requests.Method.BlockResults,
                params: { height: height },
            };
            return this.doCall(query, this.p.encodeBlockResults, this.r.decodeBlockResults);
        });
    }
    blockchain(minHeight, maxHeight) {
        return __awaiter(this, void 0, void 0, function* () {
            const query = {
                method: requests.Method.Blockchain,
                params: {
                    minHeight: minHeight,
                    maxHeight: maxHeight,
                },
            };
            return this.doCall(query, this.p.encodeBlockchain, this.r.decodeBlockchain);
        });
    }
    /**
     * Broadcast transaction to mempool and wait for response
     *
     * @see https://tendermint.com/rpc/#broadcasttxsync
     */
    broadcastTxSync(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const query = { params: params, method: requests.Method.BroadcastTxSync };
            return this.doCall(query, this.p.encodeBroadcastTx, this.r.decodeBroadcastTxSync);
        });
    }
    /**
     * Broadcast transaction to mempool and do not wait for result
     *
     * @see https://tendermint.com/rpc/#broadcasttxasync
     */
    broadcastTxAsync(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const query = { params: params, method: requests.Method.BroadcastTxAsync };
            return this.doCall(query, this.p.encodeBroadcastTx, this.r.decodeBroadcastTxAsync);
        });
    }
    /**
     * Broadcast transaction to mempool and wait for block
     *
     * @see https://tendermint.com/rpc/#broadcasttxcommit
     */
    broadcastTxCommit(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const query = { params: params, method: requests.Method.BroadcastTxCommit };
            return this.doCall(query, this.p.encodeBroadcastTx, this.r.decodeBroadcastTxCommit);
        });
    }
    commit(height) {
        return __awaiter(this, void 0, void 0, function* () {
            const query = { method: requests.Method.Commit, params: { height: height } };
            return this.doCall(query, this.p.encodeCommit, this.r.decodeCommit);
        });
    }
    genesis() {
        return __awaiter(this, void 0, void 0, function* () {
            const query = { method: requests.Method.Genesis };
            return this.doCall(query, this.p.encodeGenesis, this.r.decodeGenesis);
        });
    }
    health() {
        return __awaiter(this, void 0, void 0, function* () {
            const query = { method: requests.Method.Health };
            return this.doCall(query, this.p.encodeHealth, this.r.decodeHealth);
        });
    }
    status() {
        return __awaiter(this, void 0, void 0, function* () {
            const query = { method: requests.Method.Status };
            return this.doCall(query, this.p.encodeStatus, this.r.decodeStatus);
        });
    }
    subscribeNewBlock() {
        const request = {
            method: requests.Method.Subscribe,
            query: { type: requests.SubscriptionEventType.NewBlock },
        };
        return this.subscribe(request, this.r.decodeNewBlockEvent);
    }
    subscribeNewBlockHeader() {
        const request = {
            method: requests.Method.Subscribe,
            query: { type: requests.SubscriptionEventType.NewBlockHeader },
        };
        return this.subscribe(request, this.r.decodeNewBlockHeaderEvent);
    }
    subscribeTx(query) {
        const request = {
            method: requests.Method.Subscribe,
            query: {
                type: requests.SubscriptionEventType.Tx,
                raw: query,
            },
        };
        return this.subscribe(request, this.r.decodeTxEvent);
    }
    tx(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const query = { params: params, method: requests.Method.Tx };
            return this.doCall(query, this.p.encodeTx, this.r.decodeTx);
        });
    }
    /**
     * Search for transactions that are in a block
     *
     * @see https://tendermint.com/rpc/#txsearch
     */
    txSearch(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const query = { params: params, method: requests.Method.TxSearch };
            const resp = yield this.doCall(query, this.p.encodeTxSearch, this.r.decodeTxSearch);
            return Object.assign({}, resp, { 
                // make sure we sort by height, as tendermint may be sorting by string value of the height
                txs: [...resp.txs].sort((a, b) => a.height - b.height) });
        });
    }
    // this should paginate through all txSearch options to ensure it returns all results.
    // starts with page 1 or whatever was provided (eg. to start on page 7)
    txSearchAll(params) {
        return __awaiter(this, void 0, void 0, function* () {
            let page = params.page || 1;
            // tslint:disable-next-line:readonly-array
            const txs = [];
            let done = false;
            while (!done) {
                const resp = yield this.txSearch(Object.assign({}, params, { page: page }));
                txs.push(...resp.txs);
                if (txs.length < resp.totalCount) {
                    page++;
                }
                else {
                    done = true;
                }
            }
            // make sure we sort by height, as tendermint may be sorting by string value of the height
            // and the earlier items may be in a higher page than the later items
            txs.sort((a, b) => a.height - b.height);
            return {
                totalCount: txs.length,
                txs: txs,
            };
        });
    }
    validators(height) {
        return __awaiter(this, void 0, void 0, function* () {
            const query = {
                method: requests.Method.Validators,
                params: { height: height },
            };
            return this.doCall(query, this.p.encodeValidators, this.r.decodeValidators);
        });
    }
    // doCall is a helper to handle the encode/call/decode logic
    doCall(request, encode, decode) {
        return __awaiter(this, void 0, void 0, function* () {
            const req = encode(request);
            const result = yield this.client.execute(req);
            return decode(result);
        });
    }
    subscribe(request, decode) {
        if (!rpcclients_1.instanceOfRpcStreamingClient(this.client)) {
            throw new Error("This RPC client type cannot subscribe to events");
        }
        const req = this.p.encodeSubscribe(request);
        const eventStream = this.client.listen(req);
        return eventStream.map(event => {
            return decode(event);
        });
    }
}
exports.Client = Client;
//# sourceMappingURL=client.js.map